'use client'

import { useTranslate } from '@repo/shared/hooks'
import {
  SegmentedGroup,
  SegmentedGroupItem,
  Typography,
} from '@repo/ui/components'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

export const SettingsTheme = () => {
  const { t } = useTranslate()
  const [mounted, setMounted] = useState(false)
  const { theme, setTheme } = useTheme()

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div className='flex flex-col md:flex-row md:items-center justify-between gap-lg'>
      <Typography size='sm' color='text-neutral-surface-100' weight='bold'>
        {t('profileSettingsPage_theme_title')}
      </Typography>

      <SegmentedGroup
        value={theme}
        onValueChange={setTheme}
        color='neutral'
        className='w-full md:w-fit'
      >
        <SegmentedGroupItem value='system' id='theme-system' className='flex-1'>
          {t('profileSettingsPage_theme_auto')}
        </SegmentedGroupItem>

        <SegmentedGroupItem value='light' id='theme-light' className='flex-1'>
          {t('profileSettingsPage_theme_light')}
        </SegmentedGroupItem>

        <SegmentedGroupItem value='dark' id='theme-night' className='flex-1'>
          {t('profileSettingsPage_theme_dark')}
        </SegmentedGroupItem>
      </SegmentedGroup>
    </div>
  )
}
